import ScriptHelper from "base/ScriptHelper";
import $ from "jquery";

export function loadGoogleMap($element) {
    ScriptHelper.load_script("https://maps.googleapis.com/maps/api/js?key=AIzaSyALIV9KE7xv-qRbMO1TKxXExkuBO5yS6sQ").then(() => {
        loadMap($element);
    });
}

function loadMap($element) {

    const mapOptions = {
        disableDefaultUI: false,
        center: new google.maps.LatLng(0, 0),
        styles: MAP_STYLES,
        gestureHandling: 'cooperative',
        backgroundColor: '#FFF',
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: false,
        zoom: 18,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    let $markers = $element.find('.js-marker');

    let map = new google.maps.Map($element[0], mapOptions);

    map.markers = [];

    $markers.each((function () {
        initMarker($(this), map);
    }));

    centerMap(map);
}

export function initMarker($marker, map) {
    let infowindow;
    let latLng = {
        lat: parseFloat($marker.data('lat')),
        lng: parseFloat($marker.data('lng'))
    };

    let marker = new google.maps.Marker({
        position: latLng,
        map: map,
        icon: {
            url: '/wp-content/themes/park-cottage/images/svg/main-marker.svg',
            scaledSize: new google.maps.Size(56, 81),
            labelOrigin: new google.maps.Point(22, 65),
        }
    });

    marker.addListener('click', function () {
        if (infowindow) infowindow.close();

        let $content = (
            eotwJSXFactory('div', {className: "map-tooltip"}, [
                eotwJSXFactory('h2', {className: "heading map-tooltip__heading"}, ["Park Cottage"]),
                eotwJSXFactory('p', null, ["113 West Street,", eotwJSXFactory('br'),
                    "Warwick, Warwickshire,", eotwJSXFactory('br'),
                    "CV34 6AH"]),
                eotwJSXFactory('a', {className: "map-tooltip__link", target: "_blank", rel: "noreferrer", href: "https://www.google.com/maps/dir/?api=1&destination=ParkCottage"}, ["Get directions"])
            ])
        );

        infowindow = new google.maps.InfoWindow({
            content: $content[0]
        });
        setTimeout(function () {
            $('.gm-style-iw-a').addClass('active');
        }, 100)

        infowindow.open(map, marker);
    });

    map.markers.push(marker);
}

export function centerMap(map) {
    let bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
    } else {
        map.fitBounds(bounds);
    }
}

export const MAP_STYLES = [
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#8B8B8B"
            },
            {
                "saturation": "0"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#B4934A"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#B4934A"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#F2F2F2"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#F2F2F2"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#B4934A"
            },
            {
                "lightness": "85"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#B4934A"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#B4934A"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#B4934A"
            },
            {
                "lightness": "60"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#B4934A"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": "16"
            },
            {
                "weight": "3.19"
            },
            {
                "saturation": "48"
            },
            {
                "gamma": "0.80"
            },
            {
                "hue": "#FFD200"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "color": "#FFFFFF"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#B4934A"
            },
            {
                "lightness": "60"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#B4934A"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#B4934A"
            },
            {
                "lightness": "60"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#B4934A"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#B4934A"
            },
            {
                "lightness": "60"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#B4934A"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "color": "#F2F2F2"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#B48620"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "lightness": "100"
            },
            {
                "saturation": "80"
            },
            {
                "color": "#D0BB8D"
            },
            {
                "gamma": "1.70"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#FFFFFF"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#B4934A"
            }
        ]
    }
];